var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccountCircle = function SvgAccountCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 1.818a6.67 6.67 0 0 0-6.666 6.667 6.67 6.67 0 0 0 6.667 6.667 6.67 6.67 0 0 0 6.666-6.667 6.67 6.67 0 0 0-6.666-6.667Zm0 2.667a2.336 2.336 0 0 1 2.334 2.333 2.336 2.336 0 0 1-2.333 2.334 2.336 2.336 0 0 1-2.334-2.334 2.336 2.336 0 0 1 2.334-2.333Zm0 9.333a5.339 5.339 0 0 1-4.093-1.92 6.631 6.631 0 0 1 8.187 0 5.339 5.339 0 0 1-4.093 1.92Z",
    fill: "#2C112D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .484)",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgAccountCircle;